export default __webpack_public_path__ + "static/media/gitlab-logo.463510ab.svg";